import PropTypes from 'prop-types';
import { Component } from 'react';

// Example use:
// <Transition
//   show={ true }
//   onDidMount={ () => anime({ targets: this.ref, opacity: 1 }) }
//   onWillUnmount={ () => anime({ targets: this.ref, opacity: 0 }).finished }>
//   <div ref={ ref => this.ref => ref } />
// </Transition>
//
// Transition will wait for the returned promise from onWillUnmount to unmount children

class Transition extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: Boolean(props.show),
    };
  }

  componentDidMount() {
    if (this.props.show) {
      this.props.onDidMount && this.props.onDidMount();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.show && nextProps.show) {
      this.props.onWillMount();
      this.setState({ show: true });
    }

    if (this.props.show && !nextProps.show) {
      Promise.resolve(this.props.onWillUnmount()).then(() => {
        this.setState({ show: false });
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      this.props.onDidMount && this.props.onDidMount();
    }
  }

  render() {
    return this.state.show || this.props.alwaysRender
      ? this.props.children
      : null;
  }
}

Transition.propTypes = {
  alwaysRender: PropTypes.bool,
  show: PropTypes.bool,
  onWillMount: PropTypes.func,
  onDidMount: PropTypes.func,
  onWillUnmount: PropTypes.func,
};

const noop = () => {};

Transition.defaultProps = {
  onWillMount: noop,
  onDidMount: noop,
  onWillUnmount: noop,
};

export default Transition;
